import { pickRealStore } from "@/lib/merchantStore";

type SettingsRow = { id: string; created_at?: string | null; store_name?: string | null; store_status?: string | null };
type StoresRow = { id: string; created_at?: string | null; store_name?: string | null; owner_id?: string | null; status?: string | null };

/**
 * Store mode of the merchant's REAL store (pickRealStore): a store_settings row wins over
 * the auto-created "my-store" stores row. Status comes from the same-id stores row when
 * present, otherwise from store_settings.store_status.
 */
export function resolveOwnStoreMode(
  settingsRows: SettingsRow[] | null | undefined,
  storesRows: StoresRow[] | null | undefined,
  userId: string,
): { id: string; store_name: string | null; owner_id: string; status: string | null } | null {
  const picked = pickRealStore(settingsRows, storesRows);
  if (!picked) return null;
  if (picked.source === "stores") {
    const r = picked.row;
    return { id: r.id, store_name: r.store_name ?? null, owner_id: r.owner_id ?? userId, status: r.status ?? null };
  }
  const s = picked.row;
  const same = (storesRows ?? []).find((r) => r.id === s.id);
  return { id: s.id, store_name: s.store_name ?? same?.store_name ?? null, owner_id: userId, status: same?.status ?? s.store_status ?? null };
}
